import "core-js/modules/es.array.push.js";
import { transformStr3, getformListItemsdatas, setformdata, handleHttp, formateDate } from "@/utils/utils";
import flexible from '../../utils/flexible.js';
import guideTheme from '../../components/guideTheme';
export default {
  name: 'guideIndex',
  data() {
    return {
      exhibitionParams: {
        deptId: this.$route.query.fid || '44975',
        formId: '171924',
        page: 1,
        limit: 50,
        searchStr: '',
        orderBy: 'startTime'
      },
      loading: false,
      // 上拉加载
      finished: false,
      // 上拉加载完毕
      finishedtext: '-- 已经到底啦 --',
      list: [],
      years: []
    };
  },
  components: {
    guideTheme
  },
  methods: {
    // 详情页
    toDetail(item) {
      if (item.year) return;
      let now = new Date();
      now = this.getDate(now);
      let flag = now >= this.getDate(item.startTime) && now <= this.getDate(item.endTime) || !item.endTime || !item.startTime;
      flag ? this.$router.push(`guideList?eCode=${item[10]}&fid=${this.$route.query.fid}`) : alert('暂不在开放时间');
    },
    getDate(date) {
      return Date.parse(date);
    },
    // 获取列表
    getList() {
      this.$api.singleadvanceSearch(this.exhibitionParams).then(res => {
        if (res.totalRow > 0) {
          this.loading = false;
          let years = [];
          let formatDataList = res.dataList.map((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            itemformat.image = itemformat.image.map(img => {
              return handleHttp(`https://museum.chaoxing.com/star3/origin/${img.objectId}.${img.suffix}`);
            });
            item.itemformdata = itemformat;
            // 增加年份
            if (itemformat.startTime) {
              let year = itemformat.startTime.split('-')[0];
              if (this.years.findIndex(y => {
                return y.year == year;
              }) == -1) {
                // years.push({index,year})
                this.years.push({
                  index,
                  year
                });
              }
            }
            return item.itemformdata;
          });
          this.years.map((y, i) => {
            y.year ? formatDataList.splice(y.index + i, 0, y) : '';
          });
          if (res.totalPage == 1) {
            this.finishedtext = '-- 已经到底啦 --';
            this.finished = true;
          }
          if (this.exhibitionParams.page == 1) {
            this.list = formatDataList;
          } else {
            this.list = this.list.concat(formatDataList);
            if (this.exhibitionParams.page === res.totalPage) {
              this.finished = true;
            }
          }
          this.exhibitionParams.page++;
          console.log(this.list);
        } else {
          this.list = [];
          this.finished = true;
          this.finishedtext = '';
        }
      });
    }
  },
  watch: {
    '$store.state.guideTheme.title': {
      handler: function (newVal, oldVal) {
        document.title = this.$store.state.guideTheme.title;
      }
    }
  },
  created() {
    // rem自适应
    flexible();
    if (this.$route.query.fid === '146497') document.title = '普陀博物馆特色展览';
  }
};